import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_5'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
